import { autoinject, transient } from "aurelia-dependency-injection";
import { ClientMetaComponent } from "../../../client-meta-component/client-meta-component";
import { customElement, BindingEngine, bindable } from "aurelia-framework";
import { OnboardingSession } from "../../../onboarding.session";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject()
@transient()
@customElement('single-page-form-meta-component')
export class SignlePageFormMetaComponent extends ClientMetaComponent {

    public isSubmitting: boolean;
    private _sectionOpenedClass = 'section-title-opened';
    private _sectionOpenedAlreadyClass = 'section-title-opened-already';

    //Need to be a bindable function to have loading on the submit buttom
    @bindable()
    submit: (isValidate: boolean) => Promise<void>;

    public clientFormName: string;

    constructor(bindingEngine: BindingEngine, onboardingSession: OnboardingSession, private element: Element, dialogClientService: DialogClientService, 
        protected configService: ConfigService) {
        super(bindingEngine, onboardingSession, dialogClientService, configService);
        this.clientFormName = onboardingSession.onboardingName;
        document.title = this.clientFormName;
    }

    goToPage(index: number) {
        super.goToPage(index);

        setTimeout(() => {
            this.scrollToActivePage(true, this._sectionOpenedClass);
        }, 200);
    }

    nextPage(isSavingForLater: boolean = false, isValidate: boolean = true, movingToNextSection: boolean = false): boolean {

        //Jump
        if (movingToNextSection) this.scrollToActivePage(false, this._sectionOpenedAlreadyClass);

        const nextPage = movingToNextSection ? super.nextPage() : false;
        if (!nextPage) {
            this.isSubmitting = true;
            this.submit(isValidate).then(() => {                
                if(isSavingForLater) {
                    this.isSubmitting = false;
                }
                else {
                    //do nothing as you will be redirected
                }
            }, () =>{                             
                setTimeout(() => {
                    this.scrollToActivePage(true, 'invalid-page');
                    this.isSubmitting = false;
                });
            }).catch(() => {
                this.scrollToActivePage(true, 'invalid-page');
                this.isSubmitting = false;
            });
        }

        setTimeout(() => {
            if (movingToNextSection) this.scrollToActivePage(true, this._sectionOpenedClass);
        }, 200);

        return nextPage;
    }

    previousPage() {
        this.scrollToActivePage(false, this._sectionOpenedAlreadyClass);

        const previousPage = super.previousPage();

        setTimeout(() => {
            this.scrollToActivePage(true, this._sectionOpenedClass);
        }, 200);

        return previousPage;
    }

    scrollToActivePage(smooth: boolean, animateTo: string, retryWait = 1000, retryCount = 20) {

        let currentCount = 1;

        const tryScroll = () => {
            const ele = $(this.element).find("." + animateTo)[0];

            if (!ele) {
                currentCount++;

                if (currentCount >= retryCount) return;

                setTimeout(() => {
                    tryScroll();
                }, retryWait);
            }
            else {
                if(ele){
                    if (smooth) {
                        ele.scrollIntoView({ behavior: 'smooth', block: "start", inline: "nearest" });
                    }
                    else {
                        ele.scrollIntoView();
                    }


                    ele.classList.remove('section-title-opened');

                    const alreadOpened = $(this.element).find(".section-title-opened-already");
                    for (const ele of alreadOpened) {
                        ele.classList.remove(this._sectionOpenedAlreadyClass);
                    }

                    ele.classList.add(this._sectionOpenedAlreadyClass);
                }
            }
        };

        tryScroll();
    }
}
